<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
</script>

<template>
  <div>
    <div class="section section_gray section_indents">
      <div class="container">
        <div class="flex flex-col lg:flex-row">
          <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
            <h2 class="title-h2 mb-6">Ответы на&nbsp;самые популярные вопросы по&nbsp;выкупу автомобиля</h2>
            <accordion>
              <accordion-item>
                <template #accordion-trigger>
                  <p class="text-gray-600">Какие авто мы выкупаем?</p>
                </template>

                <template #accordion-content>
                  <p class="text-gray-600">Мы выкупаем автомобили любой марки, модели, возраста и пробега. В любом состоянии.</p>
                </template>
              </accordion-item>

              <accordion-item>
                <template #accordion-trigger>
                  <p class="text-gray-600">Как мы оцениваем автомобили?</p>
                </template>

                <template #accordion-content>
                  <p class="text-gray-600">Мы оцениваем автомобили по актуальному рынку в зависимости от состояния. Выкупаем до 100% рыночной стоимости (в некоторых случаях и более).</p>
                </template>
              </accordion-item>

              <accordion-item>
                <template #accordion-trigger>
                  <p class="text-gray-600">Как Вы получите деньги?</p>
                </template>

                <template #accordion-content>
                  <p class="text-gray-600">Вы получаете деньги сразу после заключения договора купли-продажи на карту, наличными в кассе или в зачёт другого, выбранного Вами автомобиля.</p>
                </template>
              </accordion-item>

              <accordion-item>
                <template #accordion-trigger>
                  <p class="text-gray-600">Что делать если Вы не хотите ехать к нам?</p>
                </template>

                <template #accordion-content>
                  <p class="text-gray-600">Вам необязательно ехать в Дилерский Центр, мы приедем к Вам и оформим всё на месте.</p>
                </template>
              </accordion-item>
            </accordion>
          </div>

          <div class="relative hidden lg:block w-full lg:w-1/3 xl:w-1/4">
            <div class="static lg:absolute top-0 left-0 w-full lg:w-[calc(100%+(100vw-890px)/2)] xl:w-[calc(100%+(100vw-1140px)/2)] 2xl:w-[calc(100%+(100vw-1220px)/2)] h-full flex items-start justify-center">
              <img
                class="w-full sm:w-10/12 lg:w-full max-w-[650px] h-auto"
                src="/public/images/pages/vikup/image-35.png"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
